"use client";
import { useEffect } from "react";
import { useSessionStorage } from "../../../hooks/useSessionStorage/index.js";
const FontsLoaderClient = ({
  fontUrls
}) => {
  var _a, _b, _c;
  const [loadBetaFonts, setLoadBetaFonts] = useSessionStorage(
    "loadBetaFonts",
    "false"
  );
  const shouldLoadBetaFonts = loadBetaFonts === "true";
  useEffect(() => {
    const urlParams = typeof window !== "undefined" && new URLSearchParams(window.location.search);
    const hasFontLoadParam = urlParams && (urlParams.has("loadbetafonts") || urlParams.has("loadBetaFonts"));
    if (hasFontLoadParam && !shouldLoadBetaFonts) {
      setLoadBetaFonts("true");
    }
  }, [setLoadBetaFonts, shouldLoadBetaFonts]);
  if (shouldLoadBetaFonts) {
    let fontFamilyString = 'Helvetica Neue,"Helvetica Neue LT Pro", Helvetica, Arial, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, sans-serif';
    let betaFontsString = "";
    (_a = Object.keys(fontUrls)) == null ? void 0 : _a.forEach((fontUrl, index) => {
      if (fontUrls[fontUrl]) {
        const betaFonts = new FontFace(
          `TestBetaFont${index + 1}`,
          `url(${fontUrls[fontUrl]})`
        );
        document.fonts.add(betaFonts);
        betaFontsString = `TestBetaFont${index + 1}, ${betaFontsString}`;
      }
    });
    fontFamilyString = `${betaFontsString} ${fontFamilyString}`;
    (_c = (_b = document == null ? void 0 : document.documentElement) == null ? void 0 : _b.style) == null ? void 0 : _c.setProperty(
      "--font-family-primary",
      fontFamilyString
    );
    document.body.style.fontFamily = fontFamilyString;
  }
  return null;
};
FontsLoaderClient.displayName = "FontsLoaderClient";
export {
  FontsLoaderClient as default
};
